import { render, staticRenderFns } from "./enclosure.vue?vue&type=template&id=1313ac0a&lang=html"
import script from "./enclosure.vue?vue&type=script&lang=js"
export * from "./enclosure.vue?vue&type=script&lang=js"
import style0 from "./enclosure.vue?vue&type=style&index=0&id=1313ac0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports